import { array, boolean, object, ref, string } from "yup";

const postTemplateMessageSchema = object().shape({
  title: string().required("請填寫公版標題"),
  text: string().required("請填寫公版內容"),
});

const postMessageSchema = object().shape({
  text: string().required("請填寫訊息內容"),
  createTemplateMessage: boolean().required("請填寫是否要新增公版訊息"),
  updateTemplateMessage: boolean()
    .required("請填寫是否要儲存此版修改")
    .test(
      "not edit empty template message",
      "請選擇要修改的公版",
      function (value) {
        try {
          const templateMessageId = this.resolve(ref("templateMessageId"));
          // can't edit when there's no template message chosen
          return !(templateMessageId?.length === 0 && value);
        } catch (err) {
          console.error(err);
          return false;
        }
      },
    ),
  newTemplateMessageTitle: string().when("createTemplateMessage", {
    is: true,
    then: (schema) => schema.required("請填寫新增公版標題"),
  }),
  receiverId: array().min(1, "至少要有一名發送對象"),
});

export { postTemplateMessageSchema, postMessageSchema };
